import React from 'react';
import FeatureMark from './brand/FeatureMark';
import { features } from '../data/siteContent';

const FeaturesSection: React.FC = () => {
  return (
    <section id="features" className="section-y">
      <div className="shell">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-gutter lg:items-start">
          <header className="lg:col-span-4 lg:sticky lg:top-28">
            <p className="kicker-action">What Lexeme does</p>
            <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[3rem]">
              A reader,
              <br />
              not a course.
            </h2>
            <p className="prose-note mt-7 max-w-sm">
              Six things, in the order you meet them. Everything else the app does is in service of one
              of these.
            </p>
            <div className="mt-8 h-px w-16 bg-primary" aria-hidden="true" />
          </header>

          <ol className="list-none lg:col-span-8">
            {features.map((feature) => (
              <li
                key={feature.id}
                className="border-t border-ink/12 py-9 first:border-t-0 first:pt-0 last:pb-0"
              >
                <div className="flex gap-6 sm:gap-8">
                  <div className="flex w-9 shrink-0 flex-col items-start pt-1 sm:w-12">
                    <FeatureMark id={feature.id} />
                    <span
                      className="mt-3 font-display text-[0.8125rem] text-primary"
                      aria-hidden="true"
                    >
                      {feature.index}
                    </span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="display-sm text-[1.375rem] sm:text-[1.625rem]">{feature.title}</h3>
                    <p className="prose-note mt-3 max-w-xl">{feature.description}</p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
